/* import __COLOCATED_TEMPLATE__ from './event-part-unengaged-inbound-bot-introduction-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();